import store from '@/store'
import { BUSINESS_FEATURES } from '@/constants/business-types'
import { PACKAGE_PERMISSIONS } from '@/constants/features'
// import USER_TYPES from '@/constants/authorization/user-types'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'
import posRoutes from '@/navigation/vertical/admin/POS'
import customerRoutes from '@/navigation/vertical/admin/customer'
import reportsRoutes from '@/navigation/vertical/admin/reports'
import inventoryRoutes from '@/navigation/vertical/admin/inventory'
import b2bRoutes from '@/navigation/vertical/admin/b2b'
// import logsRoutes from '@/navigation/vertical/admin/logs'

export default [
  // {
  //   header: 'navigation.management',
  // },
  {
    title: 'navigation.orders',
    svgIcon: 'icon-orders',
    children: [
      {
        title: 'navigation.orders',
        route: 'admin:orders',
        svgIcon: 'icon-orders',
        permission: SUBUSER_PERMISSION_SLUGS.ORDERS_VIEW,
      },
      {
        title: 'navigation.product-reservations',
        route: 'admin:product-reservations',
        svgIcon: 'product-reservation',
        permission: SUBUSER_PERMISSION_SLUGS.ORDERS_RESERVATION_ORDERS_VIEW,
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.PRODUCT_RESERVATION,
        tagAddonSlug: 'product_reservation',
        hide: () => !store.getters['subscription/isProductReservationPurchased'],
      },
      {
        title: 'navigation.abandoned-orders',
        route: 'admin:abandoned-orders',
        svgIcon: 'abandoned-icon',
        permission: SUBUSER_PERMISSION_SLUGS.ORDERS_ABANDONED_VIEW,
      },
      {
        title: 'navigation.return-orders',
        route: 'admin:return-orders',
        svgIcon: 'status-returned',
        permission: [
          SUBUSER_PERMISSION_SLUGS.ORDERS_RETURN_ORDERS_VIEW,
          SUBUSER_PERMISSION_SLUGS.POS_RETURN_ORDERS_MANAGE,
        ],
      },
      {
        title: 'navigation.refunds',
        route: 'admin:refunds',
        svgIcon: 'icon-refunds',
        permission: SUBUSER_PERMISSION_SLUGS.ORDERS_REFUND,
      },
    ],
  },
  {
    title: 'display-devices.devices',
    route: 'admin:display-devices',
    svgIcon: 'icon-kds-devices',
    permission: SUBUSER_PERMISSION_SLUGS.DISPLAY_DEVICES_VIEW,
  },
  {
    title: 'features.order-display-system',
    tag: 'upgrade',
    tagPackagePermission: PACKAGE_PERMISSIONS.KITCHEN,
    svgIcon: 'icon-ods',
    hide: () => store.getters['ordering/isDineinViewOnlyEnabled'] || !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.KITCHEN),
    route: 'admin:kitchen',
    permission: [
      SUBUSER_PERMISSION_SLUGS.ORDER_DISPLAY_VIEW,
      SUBUSER_PERMISSION_SLUGS.ORDER_DISPLAY_MANAGE,
    ],
  },
  {
    title: 'navigation.transactions',
    svgIcon: 'icon-payment-transactions',
    hide: () => !store.getters['subscription/isOnlinePaymentPurchased'],
    route: 'admin:transactions',
    permission: SUBUSER_PERMISSION_SLUGS.TRANSACTIONS_VIEW,
  },
  ...customerRoutes,
  // ...customerRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] })),
  ...reportsRoutes,
  // ...reportsRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] })),
  ...posRoutes,
  // ...posRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] })),
  ...inventoryRoutes,
  ...b2bRoutes,
  // ...logsRoutes,
  // {
  //   title: 'navigation.reservations',
  //   tag: 'upgrade',
  //   tagPackagePermission: PACKAGE_PERMISSIONS.RESERVATION,
  //   svgIcon: 'icon-reservation',
  //   route: 'admin:reservations',
  //   hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.RESERVE_TABLE),
  // },
  // {
  //   title: 'navigation.queues',
  //   tag: 'upgrade',
  //   tagPackagePermission: PACKAGE_PERMISSIONS.QUEUE,
  //   svgIcon: 'icon-queue',
  //   route: 'admin:queues',
  //   hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.QUEUE) || store.getters['subscription/isQr'],
  // },
  {
    title: 'navigation.reservations',
    tag: 'upgrade',
    tagPackagePermission: PACKAGE_PERMISSIONS.RESERVATION,
    tagAddonSlug: 'table_reservation',
    svgIcon: 'icon-reservation',
    route: 'admin:reservations',
    permission: SUBUSER_PERMISSION_SLUGS.RESERVATIONS_VIEW,
    hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.RESERVE_TABLE)
      || !store.getters['subscription/isTableReservationPurchased'],
  },
  // {
  //   title: 'navigation.queues',
  //   tag: 'upgrade',
  //   tagPackagePermission: PACKAGE_PERMISSIONS.QUEUE,
  //   svgIcon: 'icon-queue',
  //   route: 'admin:queues',
  //   permission: [
  //     SUBUSER_PERMISSION_SLUGS.QUEUES_VIEW,
  //     SUBUSER_PERMISSION_SLUGS.QUEUES_MANAGE,
  //   ],
  //   hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.QUEUE) || store.getters['subscription/isQr'],
  // },
]
